export default "__VITE_ASSET__8ebb6482__"